import { render, staticRenderFns } from "./CompleteProfile.vue?vue&type=template&id=aba0f61c&scoped=true&"
import script from "./CompleteProfile.vue?vue&type=script&lang=js&"
export * from "./CompleteProfile.vue?vue&type=script&lang=js&"
import style0 from "./CompleteProfile.vue?vue&type=style&index=0&id=aba0f61c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba0f61c",
  null
  
)

export default component.exports